import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  const [route, setRoute] = useState(window.location.hash || '');
  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Simple router
  if (route === '#checkout') {
    return <CheckoutPage data-id="element-0" />;
  }
  if (route === '#thank-you') {
    return <ThankYouPage data-id="element-1" />;
  }
  // Default to Landing Page
  return <LandingPage data-id="element-2" />;
}